import React from "react";
import { motion } from "framer-motion";
import { LOGO_TRANSPARENT } from "../data/mock";

export const MascotDivider = () => {
  return (
    <div className="relative py-6 bg-white overflow-hidden">
      <div className="flex items-center justify-center">
        <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#16C79A]/20 to-transparent" />
        <motion.div
          animate={{ y: [-3, 3, -3], rotate: [-2, 2, -2] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
          className="mx-6"
        >
          <img
            src={LOGO_TRANSPARENT}
            alt="Steamers mascot"
            className="w-24 h-auto object-contain drop-shadow-md"
          />
        </motion.div>
        <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#16C79A]/20 to-transparent" />
      </div>
    </div>
  );
};
